// 予約ボタンの表示
document.addEventListener("DOMContentLoaded", function() {
  const button = document.getElementById("ProductSubmitButton-");
  const spanText = button.querySelector(".btn__text");
  const preorderButtonText = "予約する";
  const disabledClass = "disabled";

  setTimeout(() => {
    if (spanText.textContent === preorderButtonText) {
      button.classList.remove(disabledClass);
    }
  }, 6000);
});




